import './App.scss';
import './index.scss';

import { Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, useLocation } from 'react-router-dom';

import CircularProgress from '@material-ui/core/CircularProgress';
import { map } from 'lodash-es';
import { Provider } from 'react-redux';
import store from './Redux/store';
import {
  commonRouteMap,
  privateRouteMap,
  publicRouteMap,
  customerRouteMap,
  adminRouteMap,
  fraudprivateRouteMap
} from './routes';
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import CommonRoute from './routes/CommonRoute';
import AdminRoute from './routes/AdminRoute';
import CustomerRoute from 'routes/CustomerRoute';

import FraudprivateRoute from 'routes/FraudRoute';
import TermsGuard from 'shared/guards/TermsGuard';
import { initClarity } from 'utils/clarityTracking';
import { userStore } from 'store/UserStore';
import {
  flushLoginCustomerId,
  netcoreIdentify,
  netcorePageView,
} from 'utils/netcoreTracking';

type Props = {};

// SPA: the SDK only records the initial load, so send a page view per route change.
const NetcorePageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    netcorePageView();
  }, [location.pathname]);
  return null;
};

const App = (props: Props) => {

  const [customerId, user] = userStore((state: any) => [
    state.customerId,
    state.user,
    state.customer,
  ]);

    useEffect(() => {
    // if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker.addEventListener('message', (event) => {
    //     console.log('event for the service worker', event);
    //   });
    // }
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/firebase-messaging-sw.js', {
            scope: '/firebase-cloud-messaging-push-scope',
          })
          .then((registration) => {
            // console.log('Service Worker registered:', registration);
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });
      });
    }
  }, []);

    useEffect(() => {
    const id = user?.userId || customerId;
    if (!id) return;
    initClarity(id);
  }, [user?.userId, customerId]);

  // Netcore primary key is the mobile number.
  useEffect(() => {
    netcoreIdentify(user?.mobile?.value);
  }, [user?.mobile?.value]);

  // Login attribute CUSTOMER_ID, sent once the customer is known.
  useEffect(() => {
    flushLoginCustomerId(user?.mobile?.value, customerId);
  }, [customerId, user?.mobile?.value]);

  return (
    <Provider store={store}>
      <Router>
        <NetcorePageTracker />
        <Suspense
          fallback={
            <CircularProgress
              className="loading"
              disableShrink
              color="inherit"
            />
          }
        >
          <Switch>

            {/* Public + Common Routes (No Terms Required) */}
            {map(commonRouteMap, (route) => (
              <CommonRoute
                key={`commonRouter-${route.path}`}
                exact
                path={route.path}
                component={route.component}
              />
            ))}

            {map(publicRouteMap, (route) => (
              <PublicRoute
                key={`publicRouter-${route.path}`}
                exact
                path={route.path}
                component={route.component}
              />
            ))}

            <TermsGuard>

              {map(customerRouteMap, (route) => (
                <CustomerRoute
                  key={`customerRouter-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

              {map(privateRouteMap, (route) => (
                <PrivateRoute
                  key={`privateRouter-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

              {map(adminRouteMap, (route) => (
                <AdminRoute
                  key={`adminRouter-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

              {map(fraudprivateRouteMap, (route) => (
                <FraudprivateRoute
                  key={`fraudprivateRouter-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

            </TermsGuard>

          </Switch>
        </Suspense>
      </Router>
    </Provider>
  );
};

export default App;
